import React, { useRef } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import './Landscape-Carousel-With-Body-CTA-Preview.scss';
import { FifteenMp } from '@mui/icons-material';
import { handleSliderValues } from '../../../../utils/UiBuilderUtils';
const LandscapeCarouselWithBodyCTAPreview = (props) => {
  const ref = useRef(null);
  const { config } = props;
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
  };

  const setMarginTop = () => {
    const titleH2Length = config.slides.find((currentSlider) => currentSlider.titleH2.length > 45);
    if (titleH2Length) return '90px';
    return '20px';
  };
  if (ref?.current) {
    handleSliderValues(config, ref);
  }

  return (
    <div className='landscape-carousal-body-cta mx-3'>
      {config?.slides?.length && (
        <div>
          <div className='landscape-carousal-body-cta-box'>
            <Carousel
              responsive={responsive}
              autoPlay={true}
              infinite={true}
              className='landscape'
              arrows={false}
              ref={ref}
            >
              {config.slides.map((slide, key) => (
                <div key={key}>
                  <p style={{ height: setMarginTop(), marginBottom: '20px' }}>
                    {slide.titleH2 || 'H2 Title'}
                  </p>
                  {!slide?.isVideo && (
                    <div
                      className={`d-flex align-items-center justify-content-center image-box ${
                        slide?.shadowOverlay ? 'shadowed-img' : ''
                      }`}
                      key={key}
                      style={
                        slide.imgURL
                          ? {
                              backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                              backgroundSize: 'cover',
                              width: '140px',
                            }
                          : {
                              width: '140px',
                            }
                      }
                    >
                      {!slide.imgURL && <p>Image</p>}
                    </div>
                  )}
                  {slide?.isVideo && (
                    <div
                      className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`}
                      key={key}
                      style={{ height: '120px', width: '140px' }}
                    >
                      <div className='video-container-lc'>
                        <video
                          style={{
                            width: '140px',
                            height: '120px',
                            objectFit: 'fill',
                            position: 'relative',
                            top: 0,
                            left: 0,
                          }}
                          autoPlay
                          loop={slide?.loopPlayBack}
                          preload='auto'
                          src={slide?.videoURL}
                          muted
                        />
                        <div className='slide-title-lc'>{slide.videoURL ? '' : 'Video'}</div>
                      </div>
                    </div>
                  )}
                  <div className='slide-body'>
                    <p className='preview-breaks'>{slide.body || 'Body'}</p>
                    {slide?.cta?.isActive && (
                      <p className='bold-text cta-title'>{slide?.cta?.title || 'CTA Title'}</p>
                    )}
                  </div>
                </div>
              ))}
              {config.viewAll?.isActive && (
                <div className='h-100'>
                   <div style={{ height: setMarginTop(), marginBottom: '20px' }}></div>
                  <div className='d-flex justify-content-center align-items-center view-all-slide'>
                    <div>View All</div>
                  </div>
                </div>
              )}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandscapeCarouselWithBodyCTAPreview;
